import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/studentGuide/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/studentGuide/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/studentGuide', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/studentGuide', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/studentGuide/' + id)
  }
}
